import { IonToggle, IonList, IonItem } from "@ionic/react";
import { ISLANDS, SUBISLANDS } from "./IslandRegistry";
import { useIslandVisibility } from "../../components/organisms/ResonanceContext/IslandVisibilityContext";

export default function IslandSettings() {
  const { visibility, setVisibility, getTitle } = useIslandVisibility();

  const renderToggle = (key: string, style?: React.CSSProperties) => (
    <IonItem key={key} style={style}>
      <IonToggle
        justify="space-between"
        checked={visibility[key] !== false}
        onIonChange={(e) => setVisibility(key, e.detail.checked)}
      >
        {getTitle(key)}
      </IonToggle>
    </IonItem>
  );

  const renderIslandWithSubs = (island: { key: string }) => (
    <div key={island.key}>
      {renderToggle(island.key)}
      {(SUBISLANDS[island.key] || []).map((sub) =>
        renderToggle(sub.key, { paddingLeft: "1.5rem" })
      )}
    </div>
  );

  return (
    <IonList>
      {ISLANDS.top.map(renderIslandWithSubs)}
      {renderIslandWithSubs(ISLANDS.center)}
      {ISLANDS.bottom.map(renderIslandWithSubs)}
    </IonList>
  );
}
